
import { getActions } from '../sagas';

/**
 * Command `map.zoomIn`
 *
 * @typedef {Object} MultSceneForApp~Map~Commands~ZoomIn
 * @property {string} command - name of command, has value `map.zoomIn`
 */
function zoomIn(params, dispatch) {
    const addCommand = getActions(dispatch).addCommand;
    addCommand('ZOOM_IN');
}

export default {
    name: 'map.zoomIn',
    execute: zoomIn
}
